import { InputAdornment } from '@material-ui/core';
import i18n from '@opsbase/lib-i18n';
import { Palette } from '@opsbase/lib-palette';
import Validator from '@opsbase/lib-validator';
import useCallforward from '@opsbase/react-hooks/useCallforward/useCallforward';
import DataPill from '@opsbase/web-chips/DataPill';
import uniq from 'lodash/uniq';
import React, { useCallback } from 'react';
import TextFieldWithStateAndBlur from '../TextFieldWithStateAndBlur';
export function TextFieldWithEmails(props) {
    const { disabled = false, maxCount = 0, value = [], onChange, helperText: origHelperText = undefined, ...otherProps } = props;
    const maxedOut = maxCount > 0 && value.length >= maxCount;
    const helperText = maxedOut && maxCount > 1 ? i18n.t('maximum-x-allowed', { x: maxCount }) : origHelperText;
    const handleBlur = useCallback(email => {
        if (!Validator.isValid({ email }))
            return;
        onChange === null || onChange === void 0 ? void 0 : onChange(uniq([...value, email]));
    }, [onChange, value]);
    const handleDelete = useCallforward(v => () => onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(vv => vv !== v)), [value, onChange]);
    return (React.createElement(TextFieldWithStateAndBlur, { ...otherProps, white: true, disabled: disabled || maxedOut, noBorder: true, helperText: helperText, validator: Validator.schemas().validEmail, InputProps: {
            style: {
                overflowX: 'auto',
                minHeight: 58,
                border: `1px solid ${Palette.LineGrey.main}`,
            },
            startAdornment: (React.createElement(InputAdornment, { position: "start" }, value === null || value === void 0 ? void 0 : value.map((t, i) => (React.createElement(DataPill, { style: { marginLeft: 4 }, key: 'pill' + i, value: t, onDelete: handleDelete(t) }))))),
        }, inputProps: {
            style: {
                display: maxedOut ? 'none' : undefined,
                maxWidth: 400,
                minWidth: 200,
            },
        }, onBlur: handleBlur }));
}
export default TextFieldWithEmails;
